var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        user: true,
        'user--slider': _vm.isSelected,
        'user--not-selected': !_vm.isSelected,
    }},[_c('div',{staticClass:"user__avatar"},[_c('avatar',{attrs:{"size":25,"src":_vm.user.picture,"username":_vm.user.name}})],1),_c('div',{staticClass:"user__info"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.name))]),(_vm.showCalibrationIndicator)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"calibration fas fa-check",attrs:{"title":_vm.$t('nBox.userCalibrated')}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }